<template>
  <Page :response="response">
    <div class="index-table">
      <div class="index-table-nav px-i">
        <h2 class="index-table-nav-title">
          {{ $tc('empowerment.pluralized', empowerments.length) }}
        </h2>
        <router-link :to="{ name: 'New Empowerment' }" role="button" class="btn btn-secondary ihjoz-rounded-button">
          {{ $t('common.new') }}
        </router-link>
      </div>
      <div v-if="empowerments.length" class="index-table-body">
        <b-table
          :items="empowerments"
          :fields="fields"
          :busy="isBusy"
          show-empty
          hover
          borderless
          class="data-table"
          thead-class="data-table-header"
          thead-tr-class="data-table-header-row"
          tbody-class="data-table-body"
          tbody-tr-class="data-table-body-row">
          <template v-for="field in fields" v-slot:[`head(${field.key})`]="data">
            <span>{{ data.label }}</span>
            <i v-if="field.sortable" class="demo-icon icon-sort"></i>
          </template>
          <template v-slot:cell(name)="data">
            <div class="index-row-content-wrapper-cell-text">
              {{ data.item.full_name }}
            </div>
          </template>
          <template v-slot:cell(email)="data">
            <div class="index-row-content-wrapper-cell-text">
              {{ data.item.email }}
            </div>
          </template>
          <template v-slot:cell(rights)="data">
            <div class="index-row-content-wrapper-cell-text">
              {{ data.item.rights }}
            </div>
          </template>
          <template v-slot:cell(action)="data">
            <router-link :to="{ name: 'Edit Empowerment', params: { companyId: data.item.boss_id, id: data.item.id } }"
                         role="button"
                         class="index-row-link-icon">
              <i class="demo-icon icon-chevron-right" />
            </router-link>
          </template>
        </b-table>
      </div>
      <EmptyList v-else resource-name="empowerment" create-route="New Empowerment" />
    </div>
  </Page>
</template>

<script>
import store from "./EmpowermentStore";
import companyStore from "../Company/CompanyStore";

import EmpowermentMixin from "./EmpowermentMixin";
import { BTable, BPagination } from "bootstrap-vue";
import EmptyList from "../../../shared/components/UI/EmptyList.vue";

const responseStore = {
  response: null
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetchAll();

  next();
};

export default {
  name: "EmpowermentIndex",

  title () {
    return this.$t("empowerment.yourTeam") + ` - ${companyStore.currentCompany.name} - ${Dashboard.currentTenant.name}`;
  },

  components: {
    EmptyList,
    BTable,
    BPagination
  },

  mixins: [EmpowermentMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      isBusy: false,
      fields: [
        { key: "name", label: this.$t('common.name'), sortable: true },
        { key: "email", label: this.$t('common.email'), sortable: true },
        { key: "rights", label: this.$t('empowerment.rights'), sortable: true },
        { key: "action", label: "", class: "data-table-body-row-link", thClass: "data-table-header-ghost", sortable: false }
      ]
    };
  },

  computed: {
    response () {
      return this.responseStore.response;
    },

    empowerments () {
      return this.response.collection;
    }
  }
};
</script>